import React, { Component } from 'react';

import './message.css';

import { Button, Modal, ModalHeader, ModalBody } from 'reactstrap';

class MessageModal extends Component {

  render() {
    const { title, message, isOpen, toggle } = this.props;
    return (
      <div>
        <Modal isOpen={ isOpen } toggle={ toggle } className="modal-info">
        <ModalHeader toggle={ toggle }>{ title }</ModalHeader>
        <ModalBody>
          { message }
          <hr />
          <Button className="float-right" color="secondary" onClick={ toggle }>Ok</Button>
        </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default MessageModal;


// WEBPACK FOOTER //
// ./src/components/Message/index.js